import { AuthState, TokenModel, UserState } from '../models/common.model';
import { getCookie, getDecodedAccessToken, setCookie } from './coockie';

export function getMonths() {
  return [
    {name: "01", index: "01"},
    {name: "02", index: "02"},
    {name: "03", index: "03"},
    {name: "04", index: "04"},
    {name: "05", index: "05"},
    {name: "06", index: "06"},
    {name: "07", index: "07"},
    {name: "08", index: "08"},
    {name: "09", index: "09"},
    {name: "10", index: "10"},
    {name: "11", index: "11"},
    {name: "12", index: "12"}
  ];
}

export function getExpYears() {
  let cDate = new Date();
  let cYear = cDate.getFullYear();
  let exp_years = [];
  while (exp_years.length <= 15) {
    let strYear = cYear.toString();
    exp_years.push({year: cYear, val: strYear.substr(2, 2)});
    cYear++;
  }
  return exp_years;
}

export function imageExists(image_url) {

  var http = new XMLHttpRequest();

  try {
    http.open('HEAD', image_url, false);
    http.send();
  } catch (error) {
    return false;
  }

  return http.status < 400;

}

export function isOnIframe() {
  try {
    return window.self !== window.top;
  } catch (e) {
    return true;
  }
}

export function getRandomImageParam() {
  return Math.floor((Math.random() * 10000) + 1000);
}

export function resizeImage(src, newX, newY) {
  return new Promise((res, rej) => {
    const img = new Image();
    img.src = src;
    img.onload = () => {
      const elem = document.createElement('canvas');
      elem.width = newX;
      elem.height = newY;
      const ctx = elem.getContext('2d');
      ctx.drawImage(img, 0, 0, newX, newY);
      const data = ctx.canvas.toDataURL();
      res(data);
    };
    img.onerror = error => rej(error);
  });
}

export function base64ToFile(url, fileName: string): File {
  var block = url.split(";");
  var contentType = block[0].split(":")[1];
  var realData = block[1].split(",")[1];
  contentType = contentType || '';
  var sliceSize = 512;
  var byteCharacters = atob(realData);
  var byteArrays = [];
  for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
    var slice = byteCharacters.slice(offset, offset + sliceSize);
    var byteNumbers = new Array(slice.length);
    for (var i = 0; i < slice.length; i++) {
      byteNumbers[i] = slice.charCodeAt(i);
    }
    var byteArray = new Uint8Array(byteNumbers);
    byteArrays.push(byteArray);
  }
  var b: any = new Blob(byteArrays, {type: contentType});
  ;
  b.lastModifiedDate = new Date();
  b.name = fileName;
  return <File> b;
}

export function calculateAgeFromDob(birthday) {
  try {
    var ageDifMs = Date.now() - new Date(birthday).getTime();
    var ageDate = new Date(ageDifMs); // miliseconds from epoch
    var age = Math.abs(ageDate.getUTCFullYear() - 1970);
    return isNaN(age) ? 'N/A' : age;
  } catch (error) {
    return 'N/A';
  }
}

export function incrementChar(char_value) {

  let n = (char_value.split('').reduce((r, a) => r * 26 + parseInt(a, 36) - 9, 0) - 1) + 1;
  var result = '';
  do {
    result = (n % 26 + 10).toString(36) + result;
    n = Math.floor(n / 26) - 1;
  } while (n >= 0);
  return result.toUpperCase();
}

export function cardValidity(month, year) {
  let curDate = new Date();
  let curMonth = curDate.getMonth() + 1;
  let curYear = curDate.getFullYear();

  let monthParam: number = 0, yearParam: number = 0;
  if (month && typeof month == "string") {
    monthParam = parseInt(month);
  } else if (month && typeof month == "number") {
    monthParam = month;
  }

  if (year && typeof year == "string") {
    if (year.length == 4) {
      yearParam = parseInt(year);
    } else if (year.length == 2) {
      yearParam = 2000 + parseInt(year);
    } else if (year && typeof year == "number") {
      let yrStr = '' + year;
      if (yrStr.length == 4) {
        yearParam = parseInt(yrStr);
      } else if (yrStr.length == 2) {
        yearParam = 2000 + parseInt(yrStr);
      }
    }
  }

  return !(curYear == yearParam && curMonth > monthParam);

}

export function formatLogoPath(logo: string | null | undefined): string | null {
  if (!logo) {
    return null;
  }

  // Check if the logo starts with a slash and remove it
  return logo.startsWith('/') ? logo.substring(1) : logo;
}

export function getTokenValue(): TokenModel | null {
  return getDecodedAccessToken();
}

export function updateUserProperty<K extends keyof UserState>(key: K, value: UserState[K], domain: string) {
  const data = JSON.parse(getCookie('storeData') as string) as AuthState;

  if (data) {

    // Update only the specified property
    data.user[key] = value;

    // Update the cookie with the modified user data
    setCookie("storeData", JSON.stringify(data), 30, domain).then();
  }
}


